import { Component, OnInit } from '@angular/core';
// import { Router } from '@angular/router';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { User } from '../_model/user.model';
import { LoginService } from '../_service/login.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-hbo',
  templateUrl: './hbo.component.html',
  styleUrls: ['./hbo.component.scss'],
  providers: [LoginService]
})
export class HboComponent implements OnInit {
  username: string = "";
  password: string = "";
  response_type: string = "";
  client_id: string = "";
  redirect_uri: string = "";
  state: string = "";
  loggedIn: string = "";
  response: string = "";
  isLogin: boolean = false;
  invalid: boolean = false;
  invalidUri: boolean = false;
  invalidClientId: boolean = false;


  constructor(
      public router: Router,
      private activatedRoute: ActivatedRoute, 
      public _loginService: LoginService,
      private toastr: ToastrService,
    ) { }


  ngOnInit() {
        this.response_type = this.activatedRoute.snapshot.queryParams["response_type"];
        this.client_id = this.activatedRoute.snapshot.queryParams["client_id"];
        this.redirect_uri = this.activatedRoute.snapshot.queryParams["redirect_uri"];
        this.state = this.activatedRoute.snapshot.queryParams["state"];
        if (!this.response_type) {
          console.log('this.response_type',this.response_type);
          window.location.href = this.redirect_uri+'?error=invalid_request&error_description=response_type_paramenter_missing';
        }
        if (!this.client_id) {
          console.log('this.client_id',this.client_id);
          window.location.href = this.redirect_uri+'?error=invalid_request&error_description=client_id_paramenter_missing';
        }
        if (!this.state) {
          console.log('this.state',this.state);
          window.location.href = this.redirect_uri+'?error=invalid_request&error_description=state_paramenter_missing';
        }
        if (this.response_type != "code") {
          console.log('this.state',this.state);
          window.location.href = this.redirect_uri+'?error=unsupported_response_type';
        }
        if (this.client_id != 'abc123') {
          this.invalid = true;
          this.invalidClientId = true;
        }
        if (!this.redirect_uri) {
        //   if (this.redirect_uri != 'https://qa-tve.hbo-la.com/hbola-sp/accessTokenRetrieval/') {
        //     if (this.redirect_uri != 'https://stg-tve.hbopaseo.com/hbola-sp/accessTokenRetrieval/') {
        //       if (this.redirect_uri != 'https://tve.hbopaseo.com/hbola-sp/accessTokenRetrieval/') {
        //         if (this.redirect_uri != 'https://paseoauthnsp-dev.hbopaseo.com/hbola-sp/accessTokenRetrieval') {
        //           if (this.redirect_uri != 'https://paseoauthnsp-qa.hbopaseo.com/hbola-sp/accessTokenRetrieval') {
        //             if (this.redirect_uri != 'https://paseoauthnsp-stg.hbopaseo.com/hbola-sp/accessTokenRetrieval') {
                      // if (this.redirect_uri != 'https://paseoauthnsp.hbopaseo.com/hbola-sp/accessTokenRetrieval') {
                        this.invalid = true;
                        this.invalidUri = true;
                      // }
        //             }
        //           }
        //         }              
        //       }
        //     }
        //   }
        }
  }

  login(){
    let user = new User('','');
    user.username = this.username;
    user.password = this.password;

    let data = [{'username':user.username,'password':user.password}];

    this._loginService.sendLogin({ data })
    .subscribe(
      response => this.handleResponse(response),
      error => this.handleResponse(error)
      );
  }

  handleResponse(response) { 
        console.log("success",response);
    
    if(response.success){
        window.location.href = this.redirect_uri+'?state='+this.state + '&code='+response.code;
        this.loggedIn = "loggedin";
    }else if (response.error || response.status == '404'){

        if (response.response == 'access_denied') {
          window.location.href = this.redirect_uri+'?error='+response.response;
        }
        if (response.response == 'server_error') {
          window.location.href = this.redirect_uri+'?error='+response.response;
        }
        if (response.status == '404') {
          window.location.href = this.redirect_uri+'?error=temporarily_unavailable';
        }
        this.username = "";
        this.response = response.response;
        this.password = "";
        this.isLogin = response.error;
    }
  }

}
